var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0H3C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H10V18H7C6.44772 18 6 18.4477 6 19C6 19.5523 6.44772 20 7 20H11H15C15.5523 20 16 19.5523 16 19C16 18.4477 15.5523 18 15 18H12V16H19C20.6569 16 22 14.6569 22 13V3C22 1.34315 20.6569 0 19 0ZM11 14H19C19.5523 14 20 13.5523 20 13V3C20 2.44772 19.5523 2 19 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H11Z",
    fill: "#162941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.af999298d708dff6e54a3c9c0ffadae1.svg";
export { ForwardRef as ReactComponent };